(() => {
	const API_SCRIPT_ID = 'youtube-iframe-api';

	// プレイヤーセットを配列で定義
	const playersConfig = [
		{
			PLAYER_ID: 'player',
			VIDEO_ID: 'ba3RBqprJKU'
		},
		{
			PLAYER_ID: 'player-lineup',
			VIDEO_ID: 'RYbgXRdyg2g'
		}
	];

	// YouTube APIをロード
	const loadYouTubeAPI = () => new Promise((resolve) => {
		if (window.YT?.Player) return resolve();
		const old = window.onYouTubeIframeAPIReady;
		window.onYouTubeIframeAPIReady = () => {
			if (typeof old === 'function') old();
			resolve();
		};
		if (!document.getElementById(API_SCRIPT_ID)) {
			const script = document.createElement('script');
			script.id = API_SCRIPT_ID;
			script.src = 'https://www.youtube.com/iframe_api';
			document.head.appendChild(script);
		}
	});

	// 各プレイヤーを生成
	const initPlayer = (PLAYER_ID, VIDEO_ID) => {
		const container = document.getElementById(PLAYER_ID);
		if (!container) {
			console.error(`[YT] #${PLAYER_ID}が見つかりません`);
			return;
		}
		const playerDiv = document.createElement('div');
		container.insertBefore(playerDiv, container.firstChild);
		// 動画IDによってautoplayを切り替え
		const autoplayTarget = (VIDEO_ID === 'Ar_WGtoI2Dg');
		const player = new YT.Player(playerDiv, {
			videoId: VIDEO_ID,
			playerVars: {
				autoplay: autoplayTarget ? 1 : 0,
				playsinline: 1,
				rel: 0,
				modestbranding: 1,
				showinfo: 0,
				origin: location.origin
			},
			events: {
				onReady: (event) => {
					const ifr = playerDiv.querySelector('iframe');
					if (ifr) {
						ifr.setAttribute('title', 'YouTube video player');
						ifr.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
						ifr.setAttribute('allowfullscreen', '');
						ifr.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
						ifr.setAttribute('frameborder', '0');
					}
                    if (autoplayTarget) {
						event.target.mute();
						event.target.playVideo();
					}
				},
				onStateChange: (e) => {
					if (e.data === YT.PlayerState.ENDED && player && typeof player.seekTo === "function") {
						player.seekTo(0, true);
						setTimeout(() => {
							player.playVideo();
							setTimeout(() => player.pauseVideo(), 120);
						}, 100);
					}
				}
			}
		});
	};

	// 全プレイヤーを初期化
	const start = () => {
		loadYouTubeAPI().then(() => {
			playersConfig.forEach(cfg => {
				initPlayer(cfg.PLAYER_ID, cfg.VIDEO_ID);
			});
		});
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', start);
	} else {
		start();
	}
})();